import { useQuery } from "@tanstack/react-query";
import { CreditCard } from "lucide-react";
import { Link } from "react-router";
import { api } from "../../api/client";
import { ICON } from "../../components/ui";

// Free days without a card (owner, 2026-10-28: „card opțional cu îndemnuri”): once the menu is live (the
// restaurant has seen the value) or when the free days are almost over, the owner is invited to activate the
// subscription now — the first payment still waits for the end of the free days, cancel any time before it, money
// back within 14 days of any payment.

interface TrialInfo {
  status: string;
  trialEndsAt: number | null;
  paymentsEnabled: boolean;
  manageable: boolean;
}

const DAY = 86_400_000;
const day = (ms: number) => new Date(ms).toLocaleDateString("ro-RO", { day: "numeric", month: "long" });

export function TrialBanner({
  rid,
  live,
  onBillingPage,
}: {
  rid: string;
  live: boolean;
  onBillingPage: boolean;
}) {
  const billing = useQuery({
    queryKey: ["billing", rid],
    queryFn: () => api<TrialInfo>("GET", `/restaurants/${rid}/billing`),
    staleTime: 5 * 60_000,
  });
  const b = billing.data;
  if (!b || onBillingPage || !b.paymentsEnabled || b.manageable) return null;
  if (b.status !== "trialing" || !b.trialEndsAt) return null;
  const left = Math.ceil((b.trialEndsAt - Date.now()) / DAY);
  if (!live && left > 7) return null;
  // One line; how the free days, the first payment and the 14-day refund work is explained in Facturare.
  const when =
    left > 0
      ? `${left} ${left === 1 ? "zi gratuită" : "zile gratuite"} rămase · prima plată pe ${day(b.trialEndsAt)}`
      : "Perioada gratuită s-a încheiat: activează abonamentul ca să publici modificări";
  return (
    <section className="band trial-banner" aria-label="Abonament">
      <CreditCard {...ICON} aria-hidden="true" />
      <span className="band-t">{when}</span>
      <Link to="/app/billing#plans-h" className="btn btn-secondary btn-sm">
        Activează
      </Link>
    </section>
  );
}
